export enum HealthCheckApiStatus {
  Checking = 'Checking',
  Healthy = 'Healthy',
  Error = 'Error'
};
